
import React from "react";
import { Helmet } from "react-helmet";
import "../css/privacy-policy.css";

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Mumbai Airport Cab</title>

        <meta
          name="description"
          content="Privacy Policy for Mumbai Airport Cab. Learn how we collect, use, and protect your personal information when using our airport transfer, taxi booking, local and outstation travel services."
        />

        <meta
          name="keywords"
          content="Mumbai Airport Cab, Airport Taxi, Pune to Mumbai Airport Cab, Taxi Booking, Airport Transfer, Outstation Travel, Privacy Policy"
        />
      </Helmet>

      {/* Breadcrumb */}
    
    <div
      className="breadcumb-wrapper"
      style={{
        backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container z-index-common">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Privacy Policy</h1>

        </div>
      </div>
    </div>
    

      {/* Privacy Policy Section */}
      <section className="privacy-policy">
        <div className="container px-0">

          <div className="row g-0">
            <img
              src="/images/privacy.png"
              alt="Privacy Policy Mumbai Airport Cab"
            />

            <div className="col-12 col-md-12">
              <h3 className="title">Privacy Policy – Mumbai Airport Cab</h3>

              <p>
                At <b>Mumbai Airport Cab</b>, we respect your privacy and are
                committed to protecting your personal information. This Privacy
                Policy explains how we collect, use, and safeguard your data
                when you use our airport transfer, local taxi, outstation cab,
                and travel services.
              </p>

              {/* Information We Collect */}
              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>

                <p className="highlight darkcolor">1. Personal Information:</p>
                <p>
                  Name, mobile number, email address, pickup and drop locations,
                  travel dates, and payment details when you book a cab.
                </p>

                <p className="highlight darkcolor">2. Booking Information:</p>
                <p>
                  Ride details including routes, vehicle preferences,
                  passenger count, airport transfer schedules, and destination
                  information to ensure smooth service delivery.
                </p>

                <p className="highlight darkcolor">3. Device & Usage Data:</p>
                <p>
                  We may collect browser information, IP address, device type,
                  and website usage data to improve website performance and
                  customer experience.
                </p>
              </div>

              {/* How We Use Information */}
              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>

                <p className="highlight darkcolor">1. Booking & Service Delivery:</p>
                <p>
                  To process cab bookings, assign drivers, manage airport
                  transfers, and provide transportation services efficiently.
                </p>

                <p className="highlight darkcolor">2. Customer Support:</p>
                <p>
                  To send booking confirmations, trip updates, invoices,
                  customer support responses, and service notifications.
                </p>

                <p className="highlight darkcolor">3. Service Improvement:</p>
                <p>
                  To analyze customer feedback and improve service quality,
                  booking experience, and operational efficiency.
                </p>

                <p className="highlight darkcolor">4. Marketing:</p>
                <p>
                  With your consent, we may send promotional offers,
                  service updates, and travel-related information.
                  You can unsubscribe at any time.
                </p>
              </div>

              {/* Information Sharing */}
              <div className="section">
                <p className="highlight darkcolor">Information Sharing:</p>

                <p className="highlight darkcolor">1. Drivers:</p>
                <p>
                  Necessary booking information is shared with drivers
                  solely for completing transportation services.
                </p>

                <p className="highlight darkcolor">2. Service Providers:</p>
                <p>
                  Limited information may be shared with payment gateways,
                  technical service providers, and trusted partners
                  involved in service delivery.
                </p>

                <p className="highlight darkcolor">3. Legal Requirements:</p>
                <p>
                  Information may be disclosed if required by law,
                  government authorities, or legal proceedings.
                </p>
              </div>

              {/* Security */}
              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We implement industry-standard security measures to
                  protect personal information from unauthorized access,
                  misuse, or disclosure.
                </p>

                <p className="highlight darkcolor">Data Retention:</p>
                <p>
                  Personal information is retained only for as long as
                  necessary to provide services, fulfill legal obligations,
                  and resolve disputes.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You may request access, correction, update, or deletion
                  of your personal information, subject to applicable laws.
                </p>

                <p className="highlight darkcolor">Cookies:</p>
                <p>
                  Our website may use cookies and similar technologies to
                  improve user experience, analyze traffic, and enhance services.
                </p>

                <p className="highlight darkcolor">Third-Party Links:</p>
                <p>
                  Our website may contain links to third-party websites.
                  We are not responsible for the privacy practices of
                  external websites.
                </p>

                <p className="highlight darkcolor">Policy Updates:</p>
                <p>
                  We reserve the right to update this Privacy Policy from
                  time to time. Updated versions will be posted on this page.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Mumbai Airport Cab</h2>

            <p>
              For privacy-related questions, booking support, or data requests,
              please contact us:
            </p>

            <ul>
              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+919545731161">+91 9545731161</a>
              </li>

              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@mumbaiairportcabs.com">
                  booking@mumbaiairportcabs.com
                </a>
              </li>

             <li>
                <b>Address:</b>
                <br />
                Mumbai Airport Cab,
                <br />
                SAWANT SADAN 05 Ramachandra cold drinks<br /> House,
                  Near SBI Bank Nehru Road<br /> Opp Noble Medical,
                  Vile Parle<br /> East Mumbai - 400057
              </li>
            </ul>
          </div>

        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;

